import React, { useMemo } from "react";
import CountUp from "react-countup";

const FLAG_BASE = "https://flagcdn.com/20x15";

/* ── Complete ISO 3166-1 alpha-2 map (name → code) ─────────────────
   Keys are lowercase for case-insensitive lookup.
   Covers official names, common names, and frequent aliases.        */
const ISO2 = {
  afghanistan: "af",
  albania: "al",
  algeria: "dz",
  "american samoa": "as",
  andorra: "ad",
  angola: "ao",
  anguilla: "ai",
  antarctica: "aq",
  "antigua and barbuda": "ag",
  argentina: "ar",
  armenia: "am",
  aruba: "aw",
  australia: "au",
  austria: "at",
  azerbaijan: "az",
  bahamas: "bs",
  "the bahamas": "bs",
  bahrain: "bh",
  bangladesh: "bd",
  barbados: "bb",
  belarus: "by",
  belgium: "be",
  belize: "bz",
  benin: "bj",
  bermuda: "bm",
  bhutan: "bt",
  bolivia: "bo",
  "plurinational state of bolivia": "bo",
  bonaire: "bq",
  "bosnia and herzegovina": "ba",
  bosnia: "ba",
  botswana: "bw",
  "bouvet island": "bv",
  brazil: "br",
  "british indian ocean territory": "io",
  brunei: "bn",
  "brunei darussalam": "bn",
  bulgaria: "bg",
  "burkina faso": "bf",
  burundi: "bi",
  "cabo verde": "cv",
  "cape verde": "cv",
  cambodia: "kh",
  cameroon: "cm",
  canada: "ca",
  "cayman islands": "ky",
  "central african republic": "cf",
  chad: "td",
  chile: "cl",
  china: "cn",
  "christmas island": "cx",
  "cocos islands": "cc",
  "cocos (keeling) islands": "cc",
  colombia: "co",
  comoros: "km",
  congo: "cg",
  "democratic republic of the congo": "cd",
  "dr congo": "cd",
  drc: "cd",
  "cook islands": "ck",
  "costa rica": "cr",
  croatia: "hr",
  cuba: "cu",
  curaçao: "cw",
  curacao: "cw",
  cyprus: "cy",
  czechia: "cz",
  "czech republic": "cz",
  czech: "cz",
  "côte d'ivoire": "ci",
  "ivory coast": "ci",
  "cote d'ivoire": "ci",
  denmark: "dk",
  djibouti: "dj",
  dominica: "dm",
  "dominican republic": "do",
  ecuador: "ec",
  egypt: "eg",
  "el salvador": "sv",
  "equatorial guinea": "gq",
  eritrea: "er",
  estonia: "ee",
  eswatini: "sz",
  swaziland: "sz",
  ethiopia: "et",
  "falkland islands": "fk",
  "faroe islands": "fo",
  fiji: "fj",
  finland: "fi",
  france: "fr",
  "french guiana": "gf",
  "french polynesia": "pf",
  "french southern territories": "tf",
  gabon: "ga",
  gambia: "gm",
  "the gambia": "gm",
  georgia: "ge",
  germany: "de",
  ghana: "gh",
  gibraltar: "gi",
  greece: "gr",
  greenland: "gl",
  grenada: "gd",
  guadeloupe: "gp",
  guam: "gu",
  guatemala: "gt",
  guernsey: "gg",
  guinea: "gn",
  "guinea-bissau": "gw",
  guyana: "gy",
  haiti: "ht",
  "heard island and mcdonald islands": "hm",
  "holy see": "va",
  vatican: "va",
  "vatican city": "va",
  honduras: "hn",
  "hong kong": "hk",
  hungary: "hu",
  iceland: "is",
  india: "in",
  indonesia: "id",
  iran: "ir",
  "islamic republic of iran": "ir",
  iraq: "iq",
  ireland: "ie",
  "republic of ireland": "ie",
  "isle of man": "im",
  israel: "il",
  italy: "it",
  jamaica: "jm",
  japan: "jp",
  jersey: "je",
  jordan: "jo",
  kazakhstan: "kz",
  kenya: "ke",
  kiribati: "ki",
  "north korea": "kp",
  "democratic people's republic of korea": "kp",
  "dpr korea": "kp",
  "south korea": "kr",
  "republic of korea": "kr",
  korea: "kr",
  kuwait: "kw",
  kyrgyzstan: "kg",
  laos: "la",
  "lao people's democratic republic": "la",
  latvia: "lv",
  lebanon: "lb",
  lesotho: "ls",
  liberia: "lr",
  libya: "ly",
  liechtenstein: "li",
  lithuania: "lt",
  luxembourg: "lu",
  macao: "mo",
  macau: "mo",
  madagascar: "mg",
  malawi: "mw",
  malaysia: "my",
  maldives: "mv",
  mali: "ml",
  malta: "mt",
  "marshall islands": "mh",
  martinique: "mq",
  mauritania: "mr",
  mauritius: "mu",
  mayotte: "yt",
  mexico: "mx",
  micronesia: "fm",
  "federated states of micronesia": "fm",
  moldova: "md",
  "republic of moldova": "md",
  monaco: "mc",
  mongolia: "mn",
  montenegro: "me",
  montserrat: "ms",
  morocco: "ma",
  mozambique: "mz",
  myanmar: "mm",
  burma: "mm",
  namibia: "na",
  nauru: "nr",
  nepal: "np",
  netherlands: "nl",
  "new caledonia": "nc",
  "new zealand": "nz",
  nicaragua: "ni",
  niger: "ne",
  nigeria: "ng",
  niue: "nu",
  "norfolk island": "nf",
  "north macedonia": "mk",
  macedonia: "mk",
  "northern mariana islands": "mp",
  norway: "no",
  oman: "om",
  pakistan: "pk",
  palau: "pw",
  palestine: "ps",
  "state of palestine": "ps",
  "occupied palestinian territory": "ps",
  panama: "pa",
  "papua new guinea": "pg",
  paraguay: "py",
  peru: "pe",
  philippines: "ph",
  pitcairn: "pn",
  poland: "pl",
  portugal: "pt",
  "puerto rico": "pr",
  qatar: "qa",
  romania: "ro",
  russia: "ru",
  "russian federation": "ru",
  rwanda: "rw",
  réunion: "re",
  reunion: "re",
  "saint barthélemy": "bl",
  "saint helena": "sh",
  "saint kitts and nevis": "kn",
  "saint lucia": "lc",
  "saint martin": "mf",
  "saint pierre and miquelon": "pm",
  "saint vincent and the grenadines": "vc",
  samoa: "ws",
  "san marino": "sm",
  "sao tome and principe": "st",
  "saudi arabia": "sa",
  senegal: "sn",
  serbia: "rs",
  seychelles: "sc",
  "sierra leone": "sl",
  singapore: "sg",
  "sint maarten": "sx",
  slovakia: "sk",
  slovenia: "si",
  "solomon islands": "sb",
  somalia: "so",
  "south africa": "za",
  "south georgia": "gs",
  "south sudan": "ss",
  spain: "es",
  "sri lanka": "lk",
  sudan: "sd",
  suriname: "sr",
  "svalbard and jan mayen": "sj",
  sweden: "se",
  switzerland: "ch",
  syria: "sy",
  "syrian arab republic": "sy",
  taiwan: "tw",
  "province of china taiwan": "tw",
  tajikistan: "tj",
  tanzania: "tz",
  "united republic of tanzania": "tz",
  thailand: "th",
  "timor-leste": "tl",
  "east timor": "tl",
  togo: "tg",
  tokelau: "tk",
  tonga: "to",
  "trinidad and tobago": "tt",
  tunisia: "tn",
  turkey: "tr",
  turkmenistan: "tm",
  "turks and caicos islands": "tc",
  tuvalu: "tv",
  uganda: "ug",
  ukraine: "ua",
  "united arab emirates": "ae",
  uae: "ae",
  "united kingdom": "gb",
  uk: "gb",
  "great britain": "gb",
  england: "gb",
  scotland: "gb",
  wales: "gb",
  britain: "gb",
  "united states of america": "us",
  "united states": "us",
  usa: "us",
  "u.s.": "us",
  "u.s.a.": "us",
  america: "us",
  "united states minor outlying islands": "um",
  uruguay: "uy",
  uzbekistan: "uz",
  vanuatu: "vu",
  venezuela: "ve",
  "bolivarian republic of venezuela": "ve",
  vietnam: "vn",
  "viet nam": "vn",
  "virgin islands british": "vg",
  "british virgin islands": "vg",
  "virgin islands us": "vi",
  "us virgin islands": "vi",
  "wallis and futuna": "wf",
  "western sahara": "eh",
  yemen: "ye",
  zambia: "zm",
  zimbabwe: "zw",
  "åland islands": "ax",
  "aland islands": "ax",
};

const getCode = (name) => ISO2[name?.toLowerCase().trim()] ?? null;

// Must stay in sync with WorldMapChart PALETTE + buildDataClasses
const PALETTE = ["#86EFAC", "#FDE68A", "#FB923C", "#60A5FA", "#A78BFA", "#EF4444"];
const TIERS   = [1, 10, 50, 100, 250, 500];

const buildDataClasses = (max) => {
  if (max <= 0) return [];
  return TIERS.map((from, i) => {
    const isLast = i === TIERS.length - 1;
    const to     = isLast ? null : TIERS[i + 1];
    return {
      from,
      ...(isLast ? {} : { to: to - 1 }),
      color: PALETTE[i],
    };
  });
};

const getColor = (count, dataClasses) => {
  const cls = dataClasses.find((dc) => count >= dc.from && (dc.to === undefined || count <= dc.to));
  return cls?.color ?? "#e2e8f0";
};

const CountryRanking = ({ data }) => {
  const dataClasses = useMemo(() => {
    const max = Math.max(...(data ?? []).map((d) => d.count ?? 0), 0);
    return buildDataClasses(max);
  }, [data]);

  if (!data?.length) {
    return (
      <div className="flex items-center justify-center h-24 text-gray-400 text-xs">
        No country data available
      </div>
    );
  }

  // Pull N/A to the end, keep top-10 of the rest
  const naEntry = data.find((d) => d.country === "N/A");
  const ranked  = data.filter((d) => d.country !== "N/A");
  const max = ranked[0]?.count ?? naEntry?.count ?? 1;
  const top = [...ranked.slice(0, 10), ...(naEntry ? [naEntry] : [])];

  return (
    <div className="flex flex-col gap-2">
      {top?.map((item, i) => {
        const code = getCode(item.country);
        const pct = (item.count / max) * 100;
        const color = getColor(item.count, dataClasses);

        const isNA = item.country === "N/A";

        return (
          <div key={item.country} className="flex items-center gap-2.5">
            {/* Rank */}
            <span className="text-[10px] text-gray-400 font-mono w-4 text-right flex-shrink-0">
              {isNA ? "—" : i + 1}
            </span>

            {/* Flag / N/A icon */}
            <div className="w-5 h-8 flex-shrink-0 flex items-center">
              {isNA ? (
                <span className="text-[13px] text-gray-400">?</span>
              ) : code ? (
                <img
                  src={`${FLAG_BASE}/${code}.png`}
                  alt={item.country}
                  width={20}
                  height={15}
                  className="rounded-[2px] object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <span className="text-[10px] text-gray-300">🌐</span>
              )}
            </div>

            {/* Country name */}
            <span className="text-xs text-gray-600 font-medium w-32 truncate flex-shrink-0">
              {item.country}
            </span>

            {/* Bar */}
            <div className="flex-1 h-4 bg-gray-50 rounded overflow-hidden">
              <div
                className="h-full rounded transition-all duration-500"
                style={{ width: `${pct}%`, backgroundColor: color }}
              />
            </div>

            {/* Count */}
            <span className="text-xs font-bold text-gray-700 w-8 text-right flex-shrink-0">
              <CountUp start={0} end={item.count} duration={1.5} separator="," />
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default CountryRanking;
